import React from "react";
import { Box, Card, Divider, Group, Stack } from "@mantine/core";
import NotificationPreferenceCell from "./NotificationPreferenceCell";
import NotificationRowLabel from "./NotificationRowLabel";
import {
  NotificationPreferencesLayoutProps,
  renderStaffIdentity,
} from "./NotificationPreferencesMatrix";
import styles from "./NotificationSettings.module.css";

/**
 * Mobile layout: one card per staff member with each notification type
 * stacked inside, so nothing needs horizontal scrolling on a phone.
 */
export const NotificationPreferenceCards: React.FC<
  NotificationPreferencesLayoutProps
> = ({
  rows,
  staff,
  staffDetails,
  editing,
  onPreferenceChange,
  onEmailOptInChange,
}) => (
  <Stack gap="md">
    {staff.map((member) => (
      <Card
        key={member.staff_user_id}
        withBorder
        padding="md"
        className={styles.card}
        aria-label={`Notification settings for ${member.first_name} ${member.last_name}`}
      >
        {renderStaffIdentity(member, staffDetails[member.staff_user_id])}
        <Divider my="sm" />
        <Stack gap="xs">
          {rows.map((row) => (
            <Group
              key={row.key}
              justify="space-between"
              wrap="nowrap"
              gap="sm"
              className={styles.cardRow}
            >
              <Box className={styles.cardRowLabel}>
                <NotificationRowLabel row={row} />
              </Box>
              <NotificationPreferenceCell
                row={row}
                staff={member}
                editing={editing}
                size="md"
                onPreferenceChange={onPreferenceChange}
                onEmailOptInChange={onEmailOptInChange}
              />
            </Group>
          ))}
        </Stack>
      </Card>
    ))}
  </Stack>
);

export default NotificationPreferenceCards;
